import { useColorMode } from '@chakra-ui/react';
import { useTheme } from '@emotion/react';
import Decimal from 'decimal.js';
import { useMemo } from 'react';
import MultiProgress from 'react-multi-progress';

type Value = string | number | Decimal | undefined;
type OptionalArray<T> = T | T[];

const renderColors = (colors: string[]) =>
  colors.map((x) => `var(--chakra-colors-${x}-200)`);
export const ProgressColorsVariant1 = renderColors([
  'blue',
  'green',
  'pink',
  'teal',
  'cyan',
  'purple',
  'yellow',
]);
export const ProgressColorsVariant2 = ProgressColorsVariant1.slice().reverse();

export interface MultiBarProps {
  variant?: 'primary' | 'secondary';
  mode?: 'values' | 'percent';
  values: OptionalArray<Value>;
  max?: OptionalArray<Value>;
}

export const MultiBar = (props: MultiBarProps) => {
  const {
    variant = 'primary',
    mode = 'values',
    max: originalMax,
    values,
    ...others
  } = props;

  const colorScheme = useColorMode();
  const maxDecimals = useMemo(
    () => toArray(originalMax).map(toDecimal),
    [originalMax]
  );
  const valueDecimals = useMemo(() => toArray(values).map(toDecimal), [values]);
  const total = useMemo(
    () => valueDecimals.reduce((sum, n) => sum.add(n), new Decimal(0)),
    [valueDecimals]
  );

  const max = useMemo(() => {
    if (maxDecimals) {
      return maxDecimals.reduce((sum, n) => sum.add(n), new Decimal(0));
    } else {
      return mode === 'percent' ? new Decimal(100) : total;
    }
  }, [maxDecimals, mode, total]);

  const chosenColors =
    variant === 'primary' ? ProgressColorsVariant1 : ProgressColorsVariant2;

  const renderedElements = useMemo(() => {
    return valueDecimals.map((v, i) => {
      const convertedValue =
        mode === 'percent' ? v.toNumber() : v.div(max).times(100).toNumber();
      debugger;
      return {
        // textColor: colorScheme.colorMode === 'dark' ? 'black' : 'white',
        // showPercentage: true,
        color: chosenColors[i],
        value: convertedValue,
      };
    });
  }, [chosenColors, max, mode, valueDecimals]);

  return (
    <MultiProgress
      {...others}
      elements={renderedElements}
      backgroundColor={'var(--chakra-colors-bg-muted)'}
    />
  );
};

function toArray<T>(v: T | T[] | undefined): T[] {
  if (!v) return [];
  return v instanceof Array ? v : [v];
}
function toDecimal(v: Value): Decimal {
  if (v instanceof Decimal) {
    return v;
  } else {
    return new Decimal(v || 0);
  }
}
